// Web Studio landing page: custom cursor, magnetic pills, scroll scrubs, industries hover preview,
// ticker rows, burger menu, CF7 modal, anchor jumps.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import $ from 'jquery';

gsap.registerPlugin(ScrollTrigger);

export default function initWebStudio() {
  if (!document.body.classList.contains('web-studio-page')) return;

  // Instant anchor jumps: capture the click before the theme-wide
  // smoothScroll handler sees it, and let the browser do its native jump.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      if (!id || !document.getElementById(id)) return;
      event.stopPropagation(); // keep smoothScroll out of it
    },
    true
  );

  // Roll-over labels: duplicate each pill's text into data-hover so the
  // scss ::after (content: attr(data-hover)) shows the same label rolling in.
  $('.wp-block-button__link, .kd-cta').each(function () {
    if (!this.getAttribute('data-hover')) {
      this.setAttribute('data-hover', $(this).text().trim());
    }
  });

  // Custom cursor
  const $cursor = $('.custom-cursor');
  const $cursorTargets = $('.wp-block-button__link, ul li a, .kd-burger');

  $(document).on('mousemove', function (e) {
    $cursor.css({
      left: e.clientX,
      top: e.clientY,
    });
  });

  $cursorTargets.on('mouseenter', function () {
    $cursor.addClass('cursor-scale');
  });

  $cursorTargets.on('mouseleave', function () {
    $cursor.removeClass('cursor-scale');
  });

  // Magnetic buttons (elastic follow)
  $(
    '.wp-block-button__link, ' +
      '.behance-footer__nav ul li a,' +
      ' .behance-header__nav ul li a, .icons a, .kd-cta--header, .p-card-link'
  ).each(function () {
    const btn = this;

    if (!btn.style.display) btn.style.display = 'flex';
    if (!btn.style.position) btn.style.position = 'relative';

    const xTo = gsap.quickTo(btn, 'x', {
      duration: 1,
      ease: 'elastic.out(1, 0.3)',
    });

    const yTo = gsap.quickTo(btn, 'y', {
      duration: 1,
      ease: 'elastic.out(1, 0.3)',
    });

    $(btn).on('mousemove', function (e) {
      const rect = btn.getBoundingClientRect();
      const { clientX, clientY } = e;

      xTo(clientX - (rect.left + rect.width / 2));
      yTo(clientY - (rect.top + rect.height / 2));
    });

    $(btn).on('mouseleave', function () {
      xTo(0);
      yTo(0);
    });
  });

  // Hero video card scale-in
  if (document.querySelector('.scale-video-block')) {
    gsap.fromTo(
      '.scale-video-block',
      { scale: 0.5 },
      {
        scale: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.scale-video-block',
          start: 'top 95%',
          end: 'center 80%',
          scrub: 0.3,
        },
      }
    );
  }

  // Fancybox popup for the video card (old theme bound [data-fancybox]
  // globally in script.js).
  if (window.Fancybox) {
    window.Fancybox.bind('[data-fancybox]', {});
  }

  // Industries hover: cursor-following preview
  $('.industries-block').each(function () {
    const $block = $(this);
    const $industries = $block.find('.industry-item');
    const $modal = $block.find('.industries-modal-container');
    const $slider = $block.find('.industries-modal-slider');

    if (!$industries.length || !$modal.length || !$slider.length) return;

    const modal = $modal.get(0);
    const slider = $slider.get(0);

    gsap.set(modal, {
      scale: 0,
      opacity: 0,
      xPercent: -50,
      yPercent: -50,
      position: 'fixed',
      transformOrigin: 'center center',
    });

    gsap.set(slider, { yPercent: 0 });

    const xMoveModal = gsap.quickTo(modal, 'left', { duration: 0.3, ease: 'power3' });
    const yMoveModal = gsap.quickTo(modal, 'top', { duration: 0.3, ease: 'power3' });

    function showModal() {
      $modal.css('display', 'block');

      gsap.to(modal, {
        scale: 1,
        opacity: 1,
        duration: 0.25,
        ease: 'power2.out',
      });
    }

    function hideModal() {
      gsap.to(modal, {
        scale: 0,
        opacity: 0,
        duration: 0.25,
        ease: 'power2.in',
        onComplete: function () {
          $modal.css('display', 'none');
        },
      });
    }

    $block.on('mousemove', function (e) {
      xMoveModal(e.clientX);
      yMoveModal(e.clientY);
    });

    $industries.each(function (i) {
      $(this).on('mouseenter', function () {
        showModal();
        gsap.to(slider, {
          yPercent: -100 * i,
          duration: 0.4,
          ease: 'power3.inOut',
        });
      });
    });

    $block.on('mouseleave', hideModal);

    $(window).on('scroll', function () {
      const rect = $block[0].getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;

      if (!inView) {
        hideModal();
      }
    });
  });

  // Parallax gallery rows moved to components/portfolio-parallax.js so the
  // klikdigital/our-portfolio block gets the same drift on any page.

  // Process curve (elastic path drag)
  (function initCurve() {
    const path = $('#curvePath')[0];
    const $box = $('#curveBox');

    if (!path || !$box.length) return;

    const startY = 50;
    const width = 1000;
    const centerX = width / 2;

    const p0 = { x: 0, y: startY };
    const p1 = { x: centerX, y: startY };
    const p2 = { x: width, y: startY };

    const maxOffset = 80;
    const snapRadius = 60;

    let isActive = false;

    gsap.defaults({ ease: 'elastic.out(1, 0.25)' });

    function renderPath() {
      path.setAttribute('d', `M ${p0.x} ${p0.y} Q ${p1.x} ${p1.y} ${p2.x} ${p2.y}`);
    }

    renderPath();

    $box.on('mousemove mouseenter mouseover', function (e) {
      const rect = this.getBoundingClientRect();
      const localY = e.clientY - rect.top;
      const svgY = (localY / rect.height) * 100;
      const diff = svgY - startY;

      if (Math.abs(diff) < snapRadius) {
        if (!isActive) {
          isActive = true;
          gsap.killTweensOf(p1);
        }

        p1.y = startY + Math.max(Math.min(diff * 1.8, maxOffset), -maxOffset);
        renderPath();
      }
    });

    $box.on('mouseleave', function () {
      isActive = false;

      gsap.to(p1, {
        y: startY,
        duration: 0.8,
        onUpdate: renderPath,
      });
    });
  })();

  // Rounded divider + parallax-bottom scrubs
  const $rounded = $('.rounded-div-wrap');

  if ($rounded.length && document.querySelector('.parallax-top')) {
    gsap.fromTo(
      $rounded[0],
      { height: '150px' },
      {
        height: '0px',
        ease: 'none',
        scrollTrigger: {
          trigger: '.parallax-top',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  }

  gsap.utils.toArray('.parallax-bottom').forEach(function (section) {
    gsap.set(section, { y: -220 });

    gsap.fromTo(
      section,
      { y: -220 },
      {
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom-=200',
          end: 'bottom center',
          scrub: true,
        },
      }
    );
  });

  // "let`s get started" ticker (Lenis + gsap.ticker smoothing)
  (function initTicker() {
    function getScrollProgress(rect, vh) {
      const total = vh + rect.height;
      const current = vh - rect.top;
      let progress = current / total;

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      return progress;
    }

    let lenisInstance = null;

    function initLenis() {
      if (typeof window.Lenis === 'undefined') return;
      if (lenisInstance) return;

      lenisInstance = new window.Lenis();
    }

    function updateParallax() {
      const $blocks = $('.klik-parallax-block');
      if (!$blocks.length) return;

      const vh = window.innerHeight || document.documentElement.clientHeight;

      $blocks.each(function () {
        const rect = this.getBoundingClientRect();
        const rawProgress = getScrollProgress(rect, vh);
        const $block = $(this);
        const prevProgress = $block.data('parallaxProgress') ?? rawProgress;
        const smoothed = prevProgress + (rawProgress - prevProgress) * 0.15;
        $block.data('parallaxProgress', smoothed);

        $block.find('.klik-parallax-row').each(function (i) {
          const $row = $(this);

          // direction: first row left, second row right (unless set).
          let directionAttr = $row.attr('data-direction');
          if (!directionAttr) {
            directionAttr = i % 2 === 0 ? 'left' : 'right';
          }

          const direction = directionAttr === 'left' ? -1 : 1;

          const from = 150 * direction;
          const to = -150 * direction;
          const targetX = from + (to - from) * smoothed;

          let quickTo = $row.data('parallaxQuickTo');
          if (!quickTo) {
            quickTo = gsap.quickTo($row[0], 'x', {
              duration: 0.6,
              ease: 'power3.out',
            });
            $row.data('parallaxQuickTo', quickTo);
          }
          quickTo(targetX);
        });
      });
    }

    const $blocks = $('.klik-parallax-block');
    if (!$blocks.length) return;

    initLenis();
    gsap.ticker.add(function (time) {
      if (lenisInstance) {
        lenisInstance.raf(time * 1000);
      }
      updateParallax();
    });
    updateParallax();

    if (!lenisInstance) {
      $(window).on('scroll', updateParallax);
      $(window).on('resize', updateParallax);
    }
  })();

  // Fixed header compact state + burger menu
  (function initHeaderAndMenu() {
    const $header = $('#header');
    const trigger = 80;

    if ($header.length) {
      $('body').addClass('behance-page-has-fixed-header');

      const updateHeader = function () {
        if ($(window).scrollTop() > trigger) {
          if (!$header.hasClass('header--compact')) {
            $header.addClass('header--compact');
          }
        } else {
          $header.removeClass('header--compact');
        }
      };

      updateHeader();
      $(window).on('scroll', updateHeader);
    }

    const $menu = $('#kd-menu');
    const $panel = $menu.find('.kd-menu-inner');
    const $burger = $('#kd-toggle');
    const $close = $('#kd-close');
    const $links = $menu.find('.kd-menu-links li');
    const $cta = $menu.find('.kd-cta');
    const $socials = $menu.find('.kd-socials');

    if (!$menu.length || !$panel.length || !$burger.length || !$close.length) {
      return;
    }

    gsap.set($menu, { autoAlpha: 0, pointerEvents: 'none' });
    gsap.set($panel, { x: '100%' });

    gsap.set($links, { x: 90, autoAlpha: 0 });
    gsap.set([$cta, $socials], { x: 90, autoAlpha: 0 });
    gsap.set($close, { scale: 0.7, autoAlpha: 0 });

    const openTl = gsap.timeline({
      paused: true,
      defaults: { ease: 'power2.out' },
      onStart: function () {
        $menu.css('pointer-events', 'auto');
        $('body').addClass('kd-lock');
      },
    });

    openTl.to($menu, { autoAlpha: 1, duration: 0.15 }, 0);
    openTl.to($panel, { x: '0%', duration: 0.8, ease: 'power3.out' }, 0);
    openTl.to(
      $links,
      { x: 0, autoAlpha: 1, duration: 1.2, stagger: 0.1, ease: 'power3.out' },
      0.1
    );
    openTl.to(
      [$cta, $socials],
      { x: 0, autoAlpha: 1, duration: 1.2, stagger: 0.08, ease: 'power3.out' },
      0.15
    );
    openTl.to(
      $close,
      { scale: 1, autoAlpha: 1, duration: 0.5, ease: 'back.out(1.4)' },
      0.25
    );

    const closeTl = gsap.timeline({
      paused: true,
      defaults: { ease: 'power2.in' },
      onComplete: function () {
        $menu.css('pointer-events', 'none');
        $('body').removeClass('kd-lock');
        $menu.removeClass('is-open');
      },
    });

    closeTl.to($close, { scale: 0.7, autoAlpha: 0, duration: 0.3, ease: 'power2.in' }, 0);
    closeTl.to($panel, { x: '100%', duration: 0.7, ease: 'power3.in' }, 0.05);
    closeTl.to(
      $links,
      { x: 90, autoAlpha: 0, duration: 1.0, stagger: 0.07, ease: 'power2.in' },
      0
    );
    closeTl.to(
      [$cta, $socials],
      { x: 90, autoAlpha: 0, duration: 1.0, stagger: 0.07, ease: 'power2.in' },
      0
    );
    closeTl.to($menu, { autoAlpha: 0, duration: 0.01 }, '-=0.2');

    function openMenu() {
      $burger.attr('aria-expanded', 'true');
      $menu.attr('aria-hidden', 'false');
      $menu.addClass('is-open');
      openTl.play(0);
    }

    function closeMenu() {
      $burger.attr('aria-expanded', 'false');
      $menu.attr('aria-hidden', 'true');
      closeTl.play(0);
    }

    $(document).on('click', '#kd-toggle', function (e) {
      e.preventDefault();
      openMenu();
    });

    $(document).on('click', '#kd-close', function (e) {
      e.preventDefault();
      closeMenu();
    });

    $(document).on('keyup', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    $menu.on('click', function (e) {
      if ($(e.target).is('#kd-menu')) closeMenu();
    });
  })();

  // CF7 success -> thank-you modal
  document.addEventListener('wpcf7mailsent', function (event) {
    const form = event.target;
    if (!form.closest('.contactus-block')) return;

    $('#bihancePageModal').show();
  });

  $(document).on('click', '.close-modal', function () {
    $('#bihancePageModal').hide();
  });

  // Testimonials carousel pagination as "1/3"
  $(window).on('load', function () {
    $('.cb-carousel-block').each(function () {
      const $slider = $(this);
      const swiperEl = $slider.find('.swiper')[0];
      const swiperInstance = swiperEl && swiperEl.swiper;

      if (!swiperInstance) return;

      const total = swiperInstance.slides.length;

      function updatePagination() {
        $slider.find('.swiper-pagination-bullet').each(function (index) {
          $(this).text(`${index + 1}/${total}`);
        });
      }

      updatePagination();
      swiperInstance.on('slideChange', updatePagination);
    });
  });
}
